import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01">
            <h1>{{ 'user.Licence points bulk upload' | translate }}</h1>
            <ul class="actions01">
                <li>
                    <a ng-click="vm.downloadTemplate()" class="btn ico-download">
                        {{ 'user.Download bulk upload template' | translate }}
                        <small>({{ 'general.updated' | translate }}: 27.04.2020)</small>
                    </a>
                </li>
            </ul>
        </div>
        <form ng-if="!vm.success && !vm.form.errors" ng-submit="vm.uploadLicencePoints()" enctype="multipart/form-data">
            <div class="person01">
                <div class="alert nomargin alert-notify" ng-bind-html="vm.introduction"></div>
                <div class="form">
                    <form-row error="vm.form.errors.file">
                        <label class="label">{{ 'user.File' | translate }}</label>
                        <div class="items">
                            <input ngf-select="vm.setFile($file)" ng-model="vm.form.file" type="file">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isPastPeriodAllowed" ng-if="vm.PrivilegeService.canManagePastLicencePeriodPoints()">
                        <label class="label">{{ 'user.File contains past periods' | translate }}</label>
                        <div class="items">
                            <label class="switch01">
                                <input type="checkbox" ng-model="vm.form.isPastPeriodAllowed">
                                <span></span>
                            </label>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <div class="row has-error" ng-if="vm.form.errors.excel">
                        <label class="label">{{ 'import.Excel errors' | translate }} *</label>
                        <div class="items">
                            <p ng-repeat="(row, errors) in vm.form.errors.excel" ng-bind-html="vm.getExcelRowErrors(row, errors)"></p>
                        </div>
                    </div>
                    <ul class="actions01">
                        <li class="primary"><button ng-if="vm.showSubmitButton" type="submit" class="btn main">{{ 'user.Import' | translate }}</button></li>
                    </ul>
                </div>
            </div>
        </form>
        <div ng-if="vm.success" class="person01">
            <div class="alert nomargin alert-success" ng-bind-html="vm.success"></div>
            <div class="form">
                <div class="row">
                    <span class="label">{{ 'user.Count of employees to whom licence points were added' | translate }}:</span>
                    <div class="items">
                        <span class="text">{{ vm.summary.users }}</span>
                    </div>
                </div>
                <div class="row">
                    <span class="label">{{ 'user.Total amount of lines entered' | translate }}:</span>
                    <div class="items">
                        <span class="text">{{ vm.summary.affectedLines }}</span>
                    </div>
                </div>
            </div>
            <ul class="actions01">
                <li class="primary">
                    <a ng-click="vm.reset()" class="btn bordered02">{{ 'user.Upload more' | translate }}</a>
                </li>
            </ul>
        </div>
        <div ng-if="vm.form.errors" class="person01">
            <div class="alert nomargin alert-danger">
                {{ 'user.Upload was not successful. See summary below' | translate }}
            </div>
            <ul class="items08">
                <li ng-repeat="error in vm.form.errors">
                    <p class="heading">{{ error.text }}</p>
                    <p>{{ 'use.Affected rows' | translate }}: {{ error.rows.join(', ') }}</p>
                </li>
            </ul>
            <ul class="actions01">
                <li class="primary">
                    <a ng-click="vm.reset()" class="btn bordered02">{{ 'user.Retry' | translate }}</a>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, Upload, lodash, AuthResource, PrivilegeService, ModalService, $window) {
        this.$translate = $translate;
        this.Upload = Upload;
        this.lodash = lodash;
        this.AuthResource = AuthResource;
        this.PrivilegeService = PrivilegeService;
        this.ModalService = ModalService;
        this.$window = $window;
    }

    $onInit () {
        this.form = {};
        this.summary = {};
        this.introduction = this.$translate.instant('user.From this view licence points can be bulk added');
        this.showSubmitButton = true;
    }

    setFile (file) {
        this.form.file = file;
    }

    uploadLicencePoints () {
        if (this.form.isPastPeriodAllowed) {
            this.ModalService.confirm(this.$translate.instant('user.confirm_passed_period_licence_points_upload')).then(() => {
                this.upload();
            });
        }
        else {
            this.upload();
        }
    }

    upload () {
        const url = `${SEED_CORE.ENV.API_URL}user/licence-point/import`;
        this.success = false;
        this.showSubmitButton = false;

        this.Upload
            .upload({ url, data: this.form })
            .then((response) => {
                this.summary.users = response.data.users;
                this.summary.affectedLines = response.data.affectedLines;
                this.success = this.$translate.instant('user.Licence points were successfully added. See summary below.');
            })
            .catch((response) => {
                const excelErrors = this.lodash.find(response.data, (data) => {
                    return data.field === 'excel';
                });
                if (excelErrors) {
                    this.form.errors = excelErrors.message;
                }
                this.showSubmitButton = true;
            })
        ;
    }

    reset () {
        this.form = {};
        this.success = false;
        this.showSubmitButton = true;
    }

    downloadTemplate () {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const url = `${SEED_CORE.ENV.API_URL}user/licence-point/export-template?lang=${this.$translate.use()}&tacToken=${token}`;
                this.$window.open(url);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/licence/point/import/index.js